// extracted by mini-css-extract-plugin
export var avatarContainer = "_51-1";
export var largeAvatarContainer = "_51-2";
export var smallAvatarContainer = "_51-0";